 $(window).scroll(function() {
        if ($(document).scrollTop() > 700) {
          $('.stickybanner-footer').show();
           
        }
        else {
              $('.stickybanner-footer').hide();
        }
    });
$(document).ready(function(){
  setTimeout(
  function() 
  {
    //do something special
    if (window.location.href.indexOf("gf_9345") > -1) { 
      $('html, body').animate({
        scrollTop: $(window).scrollTop() + 850
      });
    }
     }, 1500);
});



 